// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"37":"Homepage","238":"ContainersDetails"}[chunkId] + "." + {"37":"25bdf28f","238":"e40551fb"}[chunkId] + ".chunk.css";
};